import React, {
  useState,
  useEffect,
} from "react";
import { useParams } from 'react-router-dom';
import getDay from "../function/getDay.js";
import getUrl from "../function/getUrl.js";
import checkLogin from "../function/checkLogin.js";
import birthdayToAge from "../function/birthdayToAge.js";

//教練年度
const DashBoardCoachYearClassList = (props) => {

    let param = useParams();

  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [result, setResult] = useState([]);
  const [trialList, setTrialList] = useState([]);
  const [follow,setFollow]=useState([])
const [coachList,setCoachList]=useState([])
const [monthList,setMonthList]=useState([])
  const currentYear = new Date().getFullYear(); // 2026
  const yearList = Array.from({ length: 3 }, (_, i) => currentYear - i);
  const [year, setYear] = useState(currentYear)

    const [coachData, setCoachData] = useState([])

  let today = getDay(0, "-");
  if (!checkLogin()) {
    window.location.href = "/logout";
  }



  useEffect(() => {
    fetch(`${url}/appGet/GetCoachDashBoard2026?year=${year}&token=${token}`)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log(json)
        setCoachData(json)

      });
  }, [year]);
 
  return (
    <>
      <div className="card" style={{ minWidth: "1200px" }}>
        <div className="card-header">年度分析報表</div>
               <div className="col-12 p-1 m-1 ">
              <span className="card-title pr-5">營業指標</span>
              <select className="form-select form-select-lg rounded p-2" aria-label="Default select example" onChange={(e) => { setYear(e.target.value) }}>
                <option disabled>選擇年度</option>
                {yearList.map((item, index) => {
                  return <option value={item}>{item}</option>
                })}

              </select>
              </div>
        <div className="card-body"> 
          <div className="row">
            <table className=" table table-striped m-1">

<tr><th colspan="10">教練{year}年度指標</th></tr>
                    <tbody>
                      {/* 年度 */}
                      {coachData.map((item, index) => (
                      // 外層的 key，通常建議用唯一的 ID，若無則暫用 index
                      <tr key={`row-${index}`}>
                        {item.map((col, colIndex) => (
                          // 內層的 key
                          <td key={`col-${colIndex}`}>{col}</td>
                        ))}
                      </tr>
                    ))}

                     

                    </tbody>
                  </table>

          </div>
        </div>
      </div>

    </>
  );
};

export default DashBoardCoachYearClassList;
